import React from 'react';
import { Save } from 'lucide-react';

interface ModalFooterProps {
  onCancel: () => void;
  onSave: () => void;
  hasChanges: boolean;
  isLoading: boolean;
  displayName: string;
}

export const ModalFooter: React.FC<ModalFooterProps> = ({
  onCancel,
  onSave,
  hasChanges,
  isLoading,
  displayName,
}) => {
  return (
    <div className="flex justify-end gap-3 pt-4">
      <button
        type="button"
        onClick={onCancel}
        className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-md transition-colors"
        disabled={isLoading}
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={!hasChanges || isLoading || !displayName.trim()}
        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-300 dark:disabled:bg-gray-600 disabled:cursor-not-allowed rounded-md transition-colors flex items-center gap-2"
      >
        <Save className="w-4 h-4" />
        <span>{isLoading ? 'Saving...' : 'Save Changes'}</span>
      </button>
    </div>
  );
};
